<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:min-h-[calc(100vh_-_90px)] overflow-x-hidden bg-white"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full md:w-1/2 px-10">
        <h6 class="text-sm uppercase">Optional</h6>
        <h1 class="text-3xl sm:text-5xl/[60px] font-bold mt-2 mb-5">
          Enable Interactive Customer Experiences
        </h1>
        <p class="text-xl text-alto-500">
          Power chat widgets, APIs, and other tools with your CSV data to create interactive experiences for your customers.
        </p>
        <ul class="list-disc ml-5 my-5">
          <li class="mb-2">Embed a widget on your web site for customers to chat with your CSV data.</li>
          <li class="mb-2">Interact with your RAG-enabled CSV through APIs to build custom experiences.</li>
          <li class="mb-2">Limit the domains that can use your widget to keep your data protected.</li>
          <li class="mb-2">Use API keys to make sure requests to your data are authorized.</li>
        </ul>
        <div class="flex flex-wrap">
          <router-link
            class="mt-5 mr-5 w-full sm:w-auto cursor-pointer"
            to="/"
          >
            <button
              aria-label="Use CSV RAG to start creating AI customer experiences powered by CSV data"
              class="uppercase text-sm bg-chateauGreen px-5 py-3 rounded-lg text-white"
            >
              Start Creating Customer Experiences
            </button>
          </router-link>
        </div>
      </div>
      <div class="py-10 w-full md:w-1/2 h-full">
        <div class="bg-chateauGreen-100 h-full flex items-center justify-center rounded-3xl">
          <img src="/img/people-learning-excel-application-for-online-sales-business-8452912-6752876.webp" alt="people learning excel application for online sales business" width="545" height="450" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
